import PropTypes from 'prop-types';
import PropsType from 'props-type';
import { SVGAttributes } from 'react';

const propTypes = {
  color: PropTypes.oneOf(['black', 'gray'] as const),
};

const defaultProps = {
  color: 'black' as const,
};

type ArrowIconProps = PropsType<typeof propTypes, typeof defaultProps> & SVGAttributes<SVGElement>;

const colors = {
  black: '#424242',
  gray: '#dedede',
};

function ArrowIcon({ color, ...props }: ArrowIconProps) {
  return (
    <svg
      {...props}
      fill="none"
      height="12"
      viewBox="0 0 7 12"
      width="7"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.27771 1.82581L1.33837 0.765145L6.8687 6.29548L1.33837 11.8258L0.27771 10.7651L4.74604 6.29548L0.27771 1.82581Z"
        fill={colors[color]}
      />
    </svg>
  );
}

ArrowIcon.propTypes = propTypes;
ArrowIcon.defaultProps = defaultProps;

export default ArrowIcon;
